import React, {useEffect, useState} from 'react';
import {ScrollView} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import Markdown from 'react-native-markdown-display';
import ExternalTemplate from '../../components/templates/external';
import {StackParamList} from '../../navigators';
import {useContextState} from '../../context/user';
import {SpinnerModal} from '../../components/modals';
import {StyleSheet} from 'react-native';
import {isWebApp} from '../../utils/platform/is-web';

type ScreenProps = NativeStackScreenProps<StackParamList, 'Terms'>;

export const TermsScreen = ({navigation}: ScreenProps) => {
  const handleGoBack = () => {
    navigation.navigate('SignIn');
  };

  const {fetchTyc, tyc} = useContextState();
  const [isLoading, setIsLoading] = useState(false);

  const retrieveTerms = async () => {
    setIsLoading(true);
    await fetchTyc();
    setIsLoading(false);
  };

  useEffect(() => {
    if (tyc == null) {
      retrieveTerms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tyc]);

  return (
    <ExternalTemplate
      title="terms-title"
      summary="terms-summary"
      backButton={{
        onPress: () => handleGoBack(),
      }}>
      <ScrollView
        paddingTop={5}
        contentInset={{bottom: 50}}
        showsVerticalScrollIndicator={isWebApp}>
        <SpinnerModal show={isLoading} />
        <Markdown style={styles} mergeStyle={true}>
          {tyc ?? ''}
        </Markdown>
      </ScrollView>
    </ExternalTemplate>
  );
};
const styles = StyleSheet.create({
  body: {
    color: 'black',
  },
});
